import { StyleSheet, Font } from '@react-pdf/renderer';

import fonts from './fonts/Roboto_Condensed/static/RobotoCondensed-Regular.ttf';
import fontRoboto from './fonts/Roboto_Condensed/static/Roboto-Regular.ttf';
import urdufont from './fonts/Vazirmatn/Vazirmatn-VariableFont_wght.ttf'

Font.register({
  family: 'Roboto Condensed', 
  src: fonts, 
});
Font.register({
    family: 'Roboto',
    src: fontRoboto, 
  });
  Font.register({
    family: "Vazirmatn",
    src: urdufont, 
  });

const pdfStyles = StyleSheet.create({
  page: {
    backgroundColor: "#FFF",
    fontFamily: 'Roboto Condensed',
  },
  section: {
    margin: 10,
    padding: 10,
    flexDirection: "column",
    marginBottom: 20,
  },
  header: {
    margin: 10,
    paddingTop: 8,
    paddingBottom: 10,
    paddingHorizontal: 10,
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#333",
  },
  headerLeft: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    paddingRight: 12,
  },
  headerBrand: {
    marginLeft: 12,
    flexDirection: "column",
    justifyContent: "center",
  },
  headerLogoPlaceholder: {
    width: 50,
    height: 50,
    borderWidth: 0.5,
    borderColor: "#ccc",
    alignItems: "center",
    justifyContent: "center",
  },
  headerLogoPlaceholderText: {
    fontSize: "8pt",
    color: "#000",
  },
  headerAddress: {
    fontSize: "9pt",
    fontFamily: "Roboto",
    color: "#000",
    marginTop: 3,
  },
  logoside: {
    marginRight: "130px",
    marginLeft: "20px",
  },
  headerinfo:{
    fontFamily: 'Roboto Condensed',
    fontWeight:'bold',
    fontSize:'18pt',
    color: "#000",
  },
  headercontent: {
    width: 300,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  headerRight: {
    alignItems: "flex-end",
    justifyContent: "flex-start",
  },
  headerContactRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: 3,
  },
  headertitle: {
    fontSize: "15pt",
    marginTop: "5px",
    fontFamily: 'Roboto Condensed',
    fontWeight:'bold'
  },
  contentwrap: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  contenttitle: {
    fontSize: "10pt",
    marginBottom: 0,
    marginRight: 5,
    fontFamily: "Roboto",
    color: "#000",
  },
  contentimg: {
    width: 10,
    height: 10,
    marginBottom: 4,
  },
  title: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  pagetitle:{
    fontSize:'15pt',
    fontWeight:'bold',
    color: "#000",
  },

  table: {
    display: "flex",
    width: "100%",
    marginBottom: 10,
  },
  tableHead: {
    flexDirection: "row",
    backgroundColor: "rgba(0,0,0,0.05)",
  },
  th: {
   
    padding: 5,
    borderStyle: "solid",
    borderWidth: 0.2,
    borderColor: "#000",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  thValue: {
    fontSize: "10pt",
    fontWeight: "bold",
    fontFamily:'Roboto',
    color: "#000",
  },
  row: {
    flexDirection: "row",
  },
  td: {
    
    padding: 5,
    borderStyle: "solid",
    borderWidth: 0.2,
    borderColor: "#000",
  },
  tdValue: {
    fontSize: "10pt",
    color: "#000",
    fontFamily:'Roboto'
  },
  pageBreak: {
    marginBottom: 30,
    breakAfter: 'always',
  },
  footer: {
    padding: "10px 20px",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderTopWidth: 1,
    borderTopColor: '#ccc',
    fontSize: '10pt',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
  },
  logoContainer: {
    flex: 1,
    alignItems: 'center',
  },
  footerText: {
    textAlign: 'center',
    color: '#000',
    fontSize: '9pt',
  },
  companyText: {
    marginTop: 5,
    fontSize: '9pt',
    color: '#000',
  },
  topData: {
    margin: "0px 10px",
    padding: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
});

export const saleReportStyles = StyleSheet.create({
  page: {
    backgroundColor: "#FFF",
    fontFamily: 'Roboto Condensed',
    paddingTop: 8,
    paddingBottom: 28,
    paddingHorizontal: 14,
  },
  header: {
    marginBottom: 8,
    paddingTop: 4,
    paddingBottom: 8,
    paddingHorizontal: 4,
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#333",
  },
  headerLeft: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    paddingRight: 8,
  },
  headerBrand: {
    marginLeft: 8,
    flexDirection: "column",
    justifyContent: "center",
  },
  headerLogoPlaceholder: {
    width: 38,
    height: 38,
    borderWidth: 0.5,
    borderColor: "#ccc",
    alignItems: "center",
    justifyContent: "center",
  },
  headerLogoPlaceholderText: {
    fontSize: "7pt",
    color: "#000",
  },
  headerAddress: {
    fontSize: "7.5pt",
    fontFamily: "Roboto",
    color: "#000",
    marginTop: 2,
  },
  headerinfo: {
    fontFamily: 'Roboto Condensed',
    fontWeight: 'bold',
    fontSize: '12pt',
    color: '#000',
  },
  headerRight: {
    alignItems: "flex-end",
    justifyContent: "flex-start",
  },
  headerContactRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: 2,
  },
  logoside: {
    marginRight: "80px",
    marginLeft: "10px",
  },
  contenttitle: {
    fontSize: "7.5pt",
    marginBottom: 0,
    marginRight: 4,
    fontFamily: "Roboto",
    color: "#000",
  },
  contentimg: {
    width: 8,
    height: 8,
    marginBottom: 2,
  },
  section: {
    margin: 4,
    padding: 2,
    flexDirection: "column",
    marginBottom: 8,
  },
  title: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  titleBlock: {
    flexDirection: "column",
    marginBottom: 6,
  },
  pagetitle: {
    fontSize: '11pt',
    fontWeight: 'bold',
    marginBottom: 2,
    color: '#000',
  },
  reportSubtitle: {
    fontSize: '8pt',
    fontFamily: 'Roboto',
    color: '#000',
    marginBottom: 1,
  },
  table: {
    display: "flex",
    width: "100%",
    marginBottom: 6,
  },
  tableHead: {
    flexDirection: "row",
    backgroundColor: "rgba(0,0,0,0.05)",
  },
  totalsRow: {
    flexDirection: "row",
    backgroundColor: "rgba(0,0,0,0.08)",
  },
  th: {
    padding: 2,
    borderStyle: "solid",
    borderWidth: 0.2,
    borderColor: "#000",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  thValue: {
    fontSize: "7.5pt",
    fontWeight: "bold",
    fontFamily: 'Roboto',
    color: "#000",
  },
  row: {
    flexDirection: "row",
    width: "100%",
  },
  td: {
    padding: 2,
    borderStyle: "solid",
    borderWidth: 0.2,
    borderColor: "#000",
  },
  tdValue: {
    fontSize: "7.5pt",
    color: "#000",
    fontFamily: 'Roboto',
  },
});

export default pdfStyles;
